import ClosingBalanceAccountOperation from "./ClosingBalanceAccountOperation.js";
import ModelFactory from "../../ModelFactory.js";
import OpeningBalanceAccountOperation from "./OpeningBalanceAccountOperation.js";
import PeriodChangeAccountOperation from "./PeriodChangeAccountOperation.js";
import YearToDateAccountOperation from "./YearToDateAccountOperation.js";

/**
 * TODO: write documentation
 */
class AccountOperationFactory extends ModelFactory {
	allClasses() {
		return [
			ClosingBalanceAccountOperation,
			OpeningBalanceAccountOperation,
			PeriodChangeAccountOperation,
			YearToDateAccountOperation,
		];
	}

	allInstances() {
		return this.allClasses().map((Class) => new Class());
	}

	_getTypeFromJson(json) {
		return json.type;
	}
}

const accountOperationFactory = new AccountOperationFactory();

export default accountOperationFactory;
